import React from 'react';

import { Route } from 'react-router-dom';

import Container from 'components/Container';
import Result from 'components/Result';
import ResultAll from 'components/ResultAll';
import 'style/App.scss';

const App = () => {
  return (
    <div className="App">
      <Route path="/" exact={true} component={Container} />
      <Route path="/result" exact={true} component={Result} />
      <Route path="/result/all" exact={true} component={ResultAll} />
    </div>
  );
};

export default App;
